import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import EventStatus from '@swf/sports/components/EventStatus/EventStatus';
import type { EventStatus as EventStatusType } from '@swf/sports/components/EventStatus/hooks/useEventStatus';
import QuickSwitcher from '@swf/sports/components/QuickSwitcher/QuickSwitcher';
import type { EventTypeId } from '@swf/sports/types/eventType';

import { TXTWCL_N0_logo } from './DefaultEventCard.messages.json';
import styles from './DefaultEventCard.scss';

export interface Props {
  eventTime: string;
  isInPlay?: boolean;
  title: string;
  eventStatusOverride?: EventStatusType;
  isTurnInPlay?: boolean;
  subTitle?: string;
  isTitleOnly?: boolean;
  eventTypeId: EventTypeId;
  logoUrl?: string;
}

const DefaultEventCard: React.FC<Props> = ({
  title,
  eventTime,
  isInPlay,
  eventStatusOverride,
  isTurnInPlay,
  subTitle,
  isTitleOnly,
  eventTypeId,
  logoUrl
}) => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div className={styles.wrapper} data-testid="default-event-card">
      <QuickSwitcher
        title={
          <>
            {logoUrl ? (
              <img src={logoUrl} alt={formatMessage(TXTWCL_N0_logo, { competitionName: title })} />
            ) : null}
            {title}
          </>
        }
      />
      {!isTitleOnly ? (
        <>
          {subTitle ? <h2 className={styles.cardSubtitle}>{subTitle}</h2> : null}
          <div className={styles.status}>
            <EventStatus
              eventTypeId={eventTypeId}
              eventStatusOverride={eventStatusOverride}
              isTurnInPlay={isTurnInPlay}
              isInPlay={isInPlay}
              startTime={eventTime}
              timeFormat="long"
              size="Small"
            />
          </div>
        </>
      ) : null}
    </div>
  );
};

export default DefaultEventCard;
